<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="data.name" label="name"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-text-field v-model="data.postcode" label="postcode"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.latitude" label="latitude"></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-text-field v-model="data.longitude" label="longitude"></v-text-field>
    </v-col>

    <v-col cols="12">
      <select-regions v-model="data.region" :single="true"></select-regions>
    </v-col>
  </v-row>
</template>

<script>
import { Strings } from '../../../utils'
import SelectRegions from '../../../components/SelectRegions'
export default {
  name: 'SuburbForm',
  props: ['data'],
  components: { SelectRegions },

  data() {
    return {
      icons: ['mdi-rewind', '', 'mdi-fast-forward'],
      baseUrl: Strings.baseUrl,
      deleteFileLoading: false
    }
  }
}
</script>

<style scoped></style>
